import axios from "axios";

const deleteStorageService = (signedUrl: string) =>
  axios({
    url: signedUrl,
    method: "DELETE",
  });

export default deleteStorageService;
